const videoPauseTogglers = document.querySelectorAll('.js-video-pause-toggler');
const videoPauseTogglersArr = Array.prototype.slice.call(videoPauseTogglers);

const videoPause = {
  initialize() {
    if (videoPauseTogglersArr.length) {
      this.createListeners();
    }
  },

  createListeners() {
    videoPauseTogglersArr.forEach((toggler) => {
      toggler.addEventListener('click', ({ currentTarget }) => {
        this.video = currentTarget.parentNode.querySelector('video');

        const isPlaying = this.isVideoPlaying(this.video);

        // Play/pause the video
        this.video[isPlaying ? 'pause' : 'play']();

        // Add class to mute button to show/hide the line
        currentTarget.parentNode.classList.toggle('is-playing', !isPlaying);

        // trackEvent('Video pauze toggle', isPlaying ? 'playing' : 'paused');
      });
    });
  },

  isVideoPlaying(video) {
    return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
  },
};

export default videoPause;
